// HT-4 · この読み取りに使われた学習内容（閲覧者は要約、管理者は詳細）
import { useEffect, useState } from 'react';
import axios from 'axios';
import { CaretDown, Sparkle } from '@phosphor-icons/react';

const LEARN = `${process.env.REACT_APP_BACKEND_URL}/api/doc-ai/learning`;

export default function LearningInfluence({ documentId }) {
  const [d, setD] = useState(null);
  const [err, setErr] = useState('');
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!documentId) return;
    const token = localStorage.getItem('token');
    axios.get(`${LEARN}/documents/${documentId}/influence`,
      { headers: token ? { Authorization: `Bearer ${token}` } : {} })
      .then((r) => setD(r.data))
      .catch(() => setErr('学習内容の情報を取得できませんでした'));
  }, [documentId]);

  if (err) {
    return (
      <p className="rounded-md border border-amber-200 bg-amber-50/60 px-4 py-2 text-[11.5px] text-amber-900"
        data-testid="learning-influence-error">{err}</p>
    );
  }
  if (!d) return null;
  return (
    <div className="overflow-hidden rounded-md border border-zinc-200"
      data-testid="learning-influence">
      <button type="button" onClick={() => setOpen((v) => !v)}
        className="flex w-full items-center justify-between bg-zinc-50 px-4 py-2.5 text-sm
          font-medium text-zinc-700 transition-colors duration-200 hover:bg-zinc-100"
        data-testid="learning-influence-toggle">
        <span className="flex items-center gap-2">
          <Sparkle size={13} className="text-teal-700" />
          {d.title_ja}
          <span className="rounded-full border border-zinc-200 bg-white px-2 py-0.5
            text-[10.5px] font-normal text-zinc-500"
            data-testid="learning-influence-badge">
            {d.used ? `${d.effects_ja.join('・') || '使用あり'}` : '使用なし'}
          </span>
        </span>
        <CaretDown size={13}
          className={`text-zinc-400 transition-transform duration-200 ${open ? 'rotate-180' : ''}`} />
      </button>
      {open && (
        <div className="space-y-2 border-t border-zinc-200 bg-white px-4 py-3">
          <p className="text-[12px] text-zinc-800" data-testid="learning-influence-summary">
            {d.summary_ja}
          </p>
          {d.items_ja.length > 0 && (
            <ul className="list-disc pl-5 text-[11.5px] text-zinc-700"
              data-testid="learning-influence-items">
              {d.items_ja.map((t, i) => <li key={`${i}-${t}`}>{t}</li>)}
            </ul>
          )}
          <ul className="list-disc pl-5 text-[11px] text-zinc-500"
            data-testid="learning-influence-guarantees">
            {d.guarantees_ja.map((t) => <li key={t}>{t}</li>)}
          </ul>
          {d.is_admin_view && d.detail && (
            <div className="rounded-md border border-zinc-100 bg-zinc-50/60 p-2.5"
              data-testid="learning-influence-detail">
              <p className="text-[11px] font-medium text-zinc-600">管理者向けの詳細</p>
              {(d.detail.applied || []).map((r, i) => (
                <p key={`${i}-${r.rule_id}-${r.field_key}`}
                  className="pt-0.5 text-[11px] text-zinc-600">
                  {r.field_label_ja || '項目'} · {r.effect_label_ja} ·
                  {` ${r.before ?? '（なし）'} → ${r.after ?? '—'}`} · {r.where_ja} ·
                  規則 {r.rule_id} · 学習 v{r.learning_version}
                </p>
              ))}
              <p className="pt-1 text-[11px] text-zinc-500">
                範囲内の規則 {d.detail.rules_in_scope ?? 0}件 ·
                使われなかった規則 {(d.detail.rules_not_applied || []).length}件 ·
                範囲外 {(d.detail.rules_out_of_scope || []).length}件 ·
                自動確定 {(d.detail.auto_confirmed_fields || []).length}件 ·
                エビデンス変更 {d.detail.evidence_modified ? 'あり' : 'なし'} ·
                モデル変更 {d.detail.model_weights_changed ? 'あり' : 'なし'}
              </p>
              {(d.detail.rules_out_of_scope || []).map((r) => (
                <p key={r.rule_id} className="text-[11px] text-zinc-500">
                  範囲外: {r.kind_label_ja} — {r.reason_ja}
                </p>
              ))}
            </div>
          )}
        </div>
      )}
    </div>
  );
}
